import React from 'react';
import { Link } from 'react-router-dom';
import { Image} from 'semantic-ui-react'
class Results extends React.Component {

  render () {
    return (
      <React.Fragment>
          <div className="ui container">
            <br/>
            <Link to ="/" >
                <Image src='/images/wireframe/404.png' size='big'  centered/>
            </Link>
          </div>
      </React.Fragment>
    )
    }
}

export default Results;
